// https://github.com/vuejs/vuex/issues/833

import Vuex from 'vuex';

if (!Vuex.Store.prototype.hasModule) {
    const _registerModule = Vuex.Store.prototype.registerModule;

    Vuex.Store.prototype.registerModule = function(path, rawModule) {
        if (!this._registeredModules) this._registeredModules = new Set();
        this._registeredModules.add(path);

        return _registerModule.call(this, path, rawModule);
    };

    Vuex.Store.prototype.hasModule = function(path) {
        if (this._registeredModules) return this._registeredModules.has(path);
        return false;
    };
}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/vuex.js